/*global FormController*/

var sendMailController = new FormController("mail_mail", {
        directory: "views/mail",
        name: "mailPopup",
        route: "send-mail",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        popup: {
            noHeader: true,
            size: "wide"
        },
    }
);

sendMailController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};
sendMailController.onCancel = function(){
    this.view.close() ;
};


function decodeEntity(inputStr) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = inputStr;
    return textarea.value;
}

sendMailController.prepareDataOnEnter = function(data, callback){
    var mail = {} ;
    mail.getRecords = data.getRecords ;
    mail.email_to = data.email_to ;
    mail.subject = decodeEntity(data.subject) ;
    mail.body_html = data.body_html.replace(/[\n\r\t\s]+/g, " ").replace(/>\s+</g,'><') ;
    mail.model = data.model;
    mail.res_id = data.res_id ;
    mail.attachments = data.attachments||[] ;
    this.api.db.multiread({
        res_company: { searchFirst: {}}
    }, function(err, reads){
        if(err){ return callback(err) ;}
        mail.email_from = data.email_from;
        if(!mail.email_from){
            mail.email_from = reads.res_company.email||"noreply@owork.fr" ;
        }
        //mail.reply_to = mail.email_from ;
        if(reads.res_company.iz_mail_from){
            mail.email_from = reads.res_company.iz_mail_from ;
        }
        this.mode = "create" ;
        callback(null, mail) ;
    }.bind(this)) ;
} ;

sendMailController.sendEmail = function(done){
    var attachments = this.data.attachments ;
    if(attachments && !Array.isArray(attachments)){
        attachments = [attachments] ;
    }

    var bodyHtml = this.data.body_html + (this.api.currentUser.iz_mail_signature||"") ;
    bodyHtml = bodyHtml.replace(/[\n\r\t\s]+/g, " ").replace(/>\s+</g,'><')
        .replace(/<p><br><\/p>/g, "<p></p>")
        .replace(/<\/p>\s*<p>/g, "<br>") ;

    this.api.email.createEml(this.data.email_to, this.data.subject, bodyHtml, attachments.join(","),function(err, msg){
        if(err){ return done(err) ;}
        // var data = new Blob([msg.eml], {type: 'message/rfc822'});
        // var objectUrl = window.URL.createObjectURL(data);
        // window.location.href = objectUrl ;
        done() ;
    }.bind(this));
} ;

sendMailController.onValidate = function(){
    this.view.longTask(function(done){
        this.view.updateData() ;
        this.sendEmail(function(err){
                    if (err) { return done(err); }
                    this.mode = 'read' ; //avoid abort input warning
                    this.view.close() ;
                    if(this.callbackAfterSent){
                this.callbackAfterSent.call(null, null, this.data) ;
                    }
                    done() ;
                }.bind(this)) ;
    }.bind(this)) ;
};


/**
 * @typedef MailPopupOptions
 * @type {object}
 * @property {string} [email_to] Email To
 * @property {string} [email_cc] Email To
 * @property {string} [subject] Email subject
 * @property {string} [body_html] Email HTML
 * @property {string} [model] Linked model (Odoo style)
 * @property {number} [res_id] linked id
 * @property {number[]} [attachments] litt of attachments ids
 */

/**
 * @param {MailPopupOptions} params
 */
window.openMailPopup = function(params, callback){
    sendMailController.navigate("~send-mail", params) ;
    sendMailController.callbackAfterSent = callback ;
} ;

module.exports = sendMailController ;
